import { React, useState } from 'react';

import Box from "@mui/material/Box";
import Sidebar from './components/sidebar';
import NewAdmin from './setNewAdmin.js';
import DelAdmin from './setDeleteAdmin.js';
import NewPassword from './setNewPW.js';


import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import KeyIcon from '@mui/icons-material/Key';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

import { Accordion, AccordionDetails, AccordionSummary, Avatar, Card, CardContent, Grid, Typography, createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';
import Link from '@mui/material/Link';

var email = localStorage.getItem("userEmail");

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function SettingsUser() {

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return(
    <ThemeProvider theme={theme}>
      <Box height={70} />
        <Box sx={{ display: "flex" }}>
          <Sidebar /> 
          <Box component="main" sx={{ flexGrow: 1, p: 5 }}>
            <div>
              <Grid container spacing={3} sx={{justifyContent: 'center', display: 'flex', flexDirection: { xs: 'column', sm: 'row'} }}>
                {/* LEFT SIDE */}
                <Grid item spacing={3}>
                  <Card sx={{ boxShadow:5, mb:1 }}>
                    <CardContent sx={{ p:5, margin: "auto" }}>
                      <Avatar sx={{ width: 100, height: 100, fontSize: '50px', margin: "auto", bgcolor: '#7C1213'}}>{email?.charAt(0).toUpperCase()}</Avatar>
                      <Typography variant="h4" sx={{ pt:3, margin: "auto", textAlign: 'center' }}>Hi, Admin!</Typography>
                      <Typography variant="subtitle1" sx={{ margin: "auto", textAlign: 'center', color: 'text.secondary' }}>{email}</Typography>

                      {/* QUICK LINKS RIGHT */}

                      {/* HEADER */}
                      <Typography variant="h5" sx={{ mb: 1, mt: 7 }}>
                        <b>QUICK LINKS</b><br/>
                      </Typography>

                      {/* LIST OF LINKS */}
                      <Typography sx={{ marginBottom: 1 }}>
                        <Link href="https://up.edu.ph/" underline="hover">University of the Philippines System</Link><br/>
                        <Link href="https://upd.edu.ph/" underline="hover">University of the Philippines Diliman</Link><br/>
                        <Link href="https://coe.upd.edu.ph//" underline="hover">UPD College of Engineering</Link><br/>
                        <Link href="https://mail.upd.edu.ph/" underline="hover">UPD Webmail</Link><br/>
                        <Link href="https://crs.upd.edu.ph/" underline="hover">UPD Computerized Registration System</Link><br/>
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                {/* RIGHT SIDE */}
                <Grid item spacing={3} sx={{ width: '70%' }}> 
                    {/* PANEL 1 - Change Account Password*/}
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>

                      {/* ABOVE THE FOLD */}
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                        <Typography sx={{ width: '40px', flexShrink: 0 }}>
                          <KeyIcon/>
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }}>
                          Change Account Password
                        </Typography>
                      </AccordionSummary>

                      {/* DETAILS */}
                      <AccordionDetails>
                        <Grid container spacing={3} sx={{ justifyContent: 'center', p: 5 }}>
                          {/* DESCRIPTION */}
                          <Grid item spacing={3} sx={{ width: '50%' }}>
                            <Typography variant="h4">
                              Change Your Password
                            </Typography>
                            <Typography variant="subtitle1">
                              Keep Your Admin Account Secure
                            </Typography>
                            <br/>
                            <Typography sx={{ color: 'text.secondary' }}>
                              Security Tip: Avoid using common or easily guessable passwords. Combine uppercase and lowercase letters, numbers, and special characters to create a strong and unique password.
                            </Typography>
                          </Grid>

                          {/* CHANGE PASSWORD FORMS */}
                          <Grid item spacing={3} sx={{ width: '50%' }}> 
                            <Typography>
                              <NewPassword/>
                            </Typography>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {/* PANEL 2 */}
                    <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                      >
                        
                        <Typography sx={{ width: '40px', flexShrink: 0 }}>
                          <PersonAddIcon/>
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }}>
                          Add Admin Account
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={3} sx={{ justifyContent: 'center', p: 5 }}>
                          {/* DESCRIPTION */}
                          <Grid item spacing={3} sx={{ width: '50%' }}>
                            <Typography variant="h4">
                              Add New Admin Account
                            </Typography>
                            <Typography variant="subtitle1">
                              Grant Admin Access to Other Users
                            </Typography>
                            <br/>
                            <Typography sx={{ color: 'text.secondary' }}>
                              Security Tip: Regularly review and update admininistrative account permissions. It is essential to regularly assess the access granted to admin accounts.
                            </Typography>
                          </Grid>

                          {/* ADD NEW ACCOUNT */}
                          <Grid item spacing={3} sx={{ width: '50%' }}> 
                            <Typography>
                              <NewAdmin />
                            </Typography>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {/* PANEL 3 */}
                    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        
                        <Typography sx={{ width: '40px', flexShrink: 0 }}>
                          <PersonRemoveIcon/> 
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }}>
                          Delete Admin Account
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={3} sx={{ justifyContent: 'center', p: 5 }}>
                          {/* DESCRIPTION */}
                          <Grid item spacing={3} sx={{ width: '50%' }}>
                            <Typography variant="h4">
                              Create New Admin Account
                            </Typography>
                            <Typography variant="subtitle1">
                              Confirm Account Deletion
                            </Typography>
                            <br/>
                            <Typography sx={{ color: 'text.secondary' }}>
                              Security Tip: It's crucial to verify that you are deleting the correct admin account. Double-check the email address to avoid unintentionally deleting the wrong account.
                            </Typography>
                          </Grid>

                          {/* DELETE ADMIN ACCOUNT */}
                          <Grid item spacing={3} sx={{ width: '50%' }}> 
                            <Typography>
                              <DelAdmin/>
                            </Typography>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                </Grid>
              </Grid>
            </div>
          </Box>
        </Box>
    </ThemeProvider> 
  )
}

export default SettingsUser